"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_context_1 = require("../_util/config-context");
exports.Badge = react_1.default.forwardRef(function Badge(_a, ref) {
    var _b;
    var _c = _a.theme, theme = _c === void 0 ? "default" : _c, dot = _a.dot, ring = _a.ring, dark = _a.dark, children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["theme", "dot", "ring", "dark", "children", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    var classSuffix = dark || dot || ring ? "-dark" : "";
    return (react_1.default.createElement("span", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-badge", className, (_b = {},
            _b[classPrefix + "-badge--radius"] = !dot && !ring,
            _b[classPrefix + "-badge--dot"] = dot && !ring,
            _b[classPrefix + "-badge--ring"] = ring,
            _b["is-blue" + classSuffix] = theme === "default",
            _b["is-success" + classSuffix] = theme === "success",
            _b["is-warning" + classSuffix] = theme === "warning",
            // @ts-ignore
            _b["is-error" + classSuffix] = theme === "danger" || theme === "error",
            _b)) }, props), children));
});
exports.Badge.displayName = "Badge";
//# sourceMappingURL=Badge.js.map